import { Tabs } from 'antd';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import { useQueryParamsAsKeyValuePair } from 'hooks/useQueryParams';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router';
import { RoleEnum } from 'types/user';
import { getNewQueryString } from 'utils';

import { checkUserIsInChatRoom } from '../TransactionMessageTab/hooks';
import { ITransactionTabsProps } from '../types';
import { getTransactionTabs } from './helpers';

const { TabPane } = Tabs;

const TransactionTabs: React.FC<ITransactionTabsProps> = ({ chatRoomData, ...props }) => {
  const history = useHistory();
  const { location } = history;
  const queryObject = useQueryParamsAsKeyValuePair();
  const tab = queryObject?.tab;
  const { id: userId, role } = useCurrentLoggedInUser();
  const isClient = role === RoleEnum.CLIENT;

  // eslint-disable-next-line react/destructuring-assignment
  const currentTransactionUnreadMessage =
    (chatRoomData?.length || 0) > 0
      ? chatRoomData?.reduce((acc, chatRoom) => {
          const chatRoomUnread = checkUserIsInChatRoom(userId, chatRoom) ? chatRoom.unreadMessagesCount || 0 : 0;
          return acc + chatRoomUnread;
        }, 0)
      : 0;
  // eslint-disable-next-line react/destructuring-assignment
  const currentTransactionScannedDocsNumber = props.transactionData?.appointment?.reduce(
    (acc, appointment) => acc + (appointment.scannedFiles?.length || 0),
    0,
  );
  const transactionTabs = useMemo(
    () => getTransactionTabs(currentTransactionUnreadMessage, currentTransactionScannedDocsNumber, isClient),
    [currentTransactionUnreadMessage, currentTransactionScannedDocsNumber, isClient],
  );

  return (
    <Tabs
      className='w-full h-full-ant-tab'
      tabBarStyle={{ paddingLeft: 16, marginBottom: 0 }}
      defaultActiveKey={tab || '0'}
      onChange={(key) => {
        const queryString = getNewQueryString(location.search, { tab: key });
        history.push({
          pathname: location.pathname,
          search: queryString,
        });
      }}>
      {transactionTabs.map((t, index) => (
        <TabPane tab={t.title} key={index}>
          <t.component {...props} chatRoomData={chatRoomData} isActive={index === parseFloat(tab || '0')} />
        </TabPane>
      ))}
    </Tabs>
  );
};

export default React.memo(TransactionTabs);
